import React from 'react'
import withAnimation from '../../../hooks/withAnimation'

const TestinomialDetailSection = ({testimonialData = {}}) => {
  return (
    <div>
        {/* Full Testimonial */}
        <div className="container mx-auto mt-12 px-6 lg:px-20">
          <h2 className="text-3xl font-bold text-center text-primary mb-6">
            {testimonialData.title}
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed">
            {testimonialData.fullStory}
          </p>
        </div>

        {/* Timeline */}
        <div className="container mx-auto my-12 px-6 lg:px-20">
          <h3 className="text-2xl font-bold text-center text-primary mb-6">
            Recovery Journey
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {testimonialData.timeline.map((milestone, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-primary text-white rounded-full flex items-center justify-center mb-4 mx-auto">
                  <span className="text-2xl">{milestone.icon}</span>
                </div>
                <h4 className="text-lg font-bold">{milestone.title}</h4>
                <p className="text-sm text-gray-600">{milestone.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Expert Involvement */}
        <div className="container mx-auto my-12 px-6 lg:px-20 bg-white p-8 rounded-lg shadow-lg">
          <div className="flex items-center">
            <img
              src={testimonialData.expertImage}
              alt="Expert"
              className="rounded-full object-cover w-32 h-24 mr-8"
            />
            <div>
              <h3 className="text-xl font-bold">
                {testimonialData.expertName}
              </h3>
              <p className="text-gray-600 mt-2">
                {testimonialData.expertQuote}
              </p>
            </div>
          </div>
        </div>

        {/* Related Stories */}
        <div className="container mx-auto my-12 px-6 lg:px-20">
          <h3 className="text-2xl font-bold text-center text-primary mb-6">
            Related Healing Stories
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonialData.relatedStories.map((story, index) => (
              <div
                key={index}
                className="bg-white p-6 rounded-lg shadow-lg text-center"
              >
                <h4 className="text-xl font-bold mb-2">{story.name}</h4>
                <p className="text-gray-700 text-sm">{story.snippet}</p>
                <button className="text-primary font-bold mt-4">
                  Read More
                </button>
              </div>
            ))}
          </div>
        </div>
    </div>
  )
}

export default withAnimation(TestinomialDetailSection)